module.exports = __webpack_public_path__ + "static/media/01-longo.59ff2c54.svg";